/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APICountry } from '@/models/api/country.model'

const resource = {
    main: 'services',
    module: 'countries'
}

export class CountriesServices {
    public static getCountries () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getCountriesPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getCountriesById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createCountries (params: APICountry) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editCountries (params: APICountry) {
        return service.put(`${resource.main}/${resource.module}/${params.countryId}`, params)
    }

    public static deleteCountries (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }

    public static restoreCountries (id: number) {
        return service.put(`${resource.main}/${resource.module}/restore/${id}`)
    }
}
